export default {
  storeNamespace: 'transfer',
  authFeature: 'transfer',
  listRouteName: "TransferList",
  newRouteName: 'TransferNew',
  editRouteName: "TransferEdit",
  detailRouteName: "TransferDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'TransferForm',
  csvExportFilenamePrefix: 'demandes-de-transfert',
  hideActionPdfButton: true,
  titleField: 'transfer_number',
  sortBy: 'transfer_number',
  sortDesc: true,
  showExtendedFilters: true,
  fields: [{
    name: 'transfer_number',
    label: "Numéro",
    type: 'text',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'user',
    label: "Demandeur",
    inDetail: true,
    inPdfExport: true,
    inCsvExport: true,
    formatter: (context, value) => value && value.firstname && value.lastname ? value.firstname + ' ' + value.lastname : null
  },
  {
    name: 'user_id',
    label: "Demandeur",
    type: 'vueselect',
    inForm: true,
    required: true,
    description: "Utilisateur E-MATERIEL pouvant effectuer un retour. Il s'agit de la liste des utilisateurs."
  },
  {
    name: 'asker_email',
    label: "Email du demandeur",
    type: 'email',
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value, item) => item && item.user && item.user.email ? item.user.email : (value ? value : null)
  },
  {
    name: 'asker_number',
    label: "Matricule du demandeur",
    type: 'text',
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value, item) => item && item.user && item.user.employee && item.user.employee.number ? item.user.employee.number : (value ? value : null)
  },
  {
    name: 'agency_number',
    label: "Agence de départ",
    type: 'chosen',
    inForm: true,
    required: true,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    inFormCondition: (form) => !form.id
  },
  {
    name: 'old_business_number',
    label: "Affaire de départ",
    type: 'chosen',
    inForm: true,
    required: true,
    firstOption: "-- Sélectionnez une agence --",
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    inFormCondition: (form) => !form.id
  },
  {
    name: 'old_business',
    label: "Affaire de départ",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value && value.number && value.name ? value.number + ' - ' + value.name : null
  },
  {
    name: 'agency',
    label: "Agence de départ",
    type: 'select',
    inForm: false,
    inList: false,
    sortable: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value && value.name ? value.name : null
  },
  {
    name: 'new_agency_number',
    label: "Agence de destination",
    type: 'chosen',
    inForm: true,
    required: true,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    inFormCondition: (form) => !form.id
  },
  {
    name: 'new_agency',
    label: "Agence de destination",
    type: 'select',
    inForm: false,
    inList: false,
    sortable: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value && value.name ? value.name : null
  },
  {
    name: 'new_business_number',
    label: "Affaire de destination",
    type: 'chosen',
    inForm: true,
    required: true,
    firstOption: "-- Sélectionnez une agence --",
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'new_business',
    label: "Affaire de destination",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value && value.number && value.name ? value.number + ' - ' + value.name : null
  },
  {
    name: 'employee_number',
    label: "Utilisateur des produits",
    type: 'vueselect',
    inForm: true,
    required: false,
    firstOption: "-- Sélectionnez une agence --",
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'employee',
    label: "Utilisateur des produits",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value && value.firstname && value.lastname && value.number ? value.firstname + ' ' + value.lastname + ' (' + value.number + ')' : null
  },
  {
    name: 'comment',
    label: "Commentaire",
    type: 'textarea',
    inForm: true,
    required: false,
    inList: false,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'group_slugs',
    label: "Services",
    type: 'select',
    inList: true,
    extendedFilter: true,
  },
  {
    name: 'axiloc_creation_date',
    label: "Création",
    type: 'date',
    inForm: false,
    inList: true,
    sortable: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inForm: false,
    inList: false,
    inDetail: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
  },
  {
    name: 'unique_references',
    label: "Références uniques",
    type: 'group_repeater',
    inForm: true,
    required: true,
    fields: [{
      name: 'id',
      label: "Référence unique",
      type: 'chosen',
      inForm: true,
      required: true,
    },]
  }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Transfer/config.js